export const DYNAMIC_TEMPLATE_DESTINATION_TYPE = {
  CAMPAIGN: 1,
  WORKFLOW: 2,
}
